import { ThemePack } from '@/types/theme-packs.types';

const isGlobalThemePack = (themePack?: ThemePack | null) => themePack?.channel === 0;

export default isGlobalThemePack;
